export default __webpack_public_path__ + "static/media/456d67a89435bf4f6e56dbc5b9a97d7c.svg";